import {
  IApiEpBillingProductPurchaseRes,
  IApiEpBillingProductPurchaseResRecurringPayment,
} from "@smp/api";

export const isRecurringPayment = (
  invoice: IApiEpBillingProductPurchaseRes,
): invoice is IApiEpBillingProductPurchaseResRecurringPayment =>
  "recurring_payment" in invoice;
